module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Regular.a2d9fbc.woff";